import { Component, AfterViewInit, OnInit } from '@angular/core';
import { ROUTES } from './menu-items';
import { RouteInfo } from './sidebar.metadata';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../common-service.service';

declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  permissionObj:any;
  public sidebarnavItems: any[];
  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private commonService:CommonService
  ) {}

  // End open close
  public userData = null;
  ngOnInit() {
    let loginData = JSON.parse(localStorage.getItem(this.commonService.prefix+'userData'));
    this.userData = JSON.parse(localStorage.getItem(this.commonService.prefix+'userData'));


    let routes;
    if(loginData.role_id != 1 && loginData.role_id != 0){
      this.permissionObj = JSON.parse(loginData.permission);
      // console.log(ROUTES);return false;
      if(this.permissionObj){
         routes = this.deleteRoutes(ROUTES);
      }
      else{
      routes = ROUTES;
      }
    }
    else if(loginData.role_id == 1){
      let arr = [];
      ROUTES.forEach((element,key)=>{
        //console.log(element.module);
        if( element.module != 'my_subscription'){
          arr.push(element)
        }
      })
      routes = arr;
    }
    else{
      routes = ROUTES;
    }
   
    this.sidebarnavItems = routes.filter(sidebarnavItem => sidebarnavItem);
  }
  deleteRoutes(routes){
    let arr=[];
    routes.forEach((element,key)=>{
      // console.log(element.module+':--'+key)
      // console.log(!this.permissionObj[element.module])
      if(element.module && !this.permissionObj[element.module]){
      }
      else{
        // alert()
        let sub = Object.assign([],element.submenu);
        element.submenu = [];
        // console.log(sub)
        if(sub){
          let array = this.deleteRoutes(sub);
          console.log(array)
          element.submenu = array;
        }
        if(element.class == "has-arrow" && element.submenu.length == 0){

        }
        else{
          arr.push(element);
        }
       
      }
      
    })
    return arr;
    // console.log(routes)
  }
}
